import {
  handleGetWardrobe,
  handleGetWardrobeOutfits,
  handleGetWardrobeProducts,
  handleCreateWardrobeOutfit,
  handleAddProductRequest,
  handleUpdateProductRequest,
  handleRemoveProductRequest
} from '@/store/api/wardrobe';

import WardrobeOutfitService from '@/services/api/WardrobeOutfitService'

function wardrobeProductIdsWithoutProducts(wardrobeProducts) {
  return wardrobeProducts.filter(wp => wp.product == null).map(x => x.id)
}

const state = {
  builderOutfit: [
    { layerSlug: 'outerwear', sequence: 0, product: null },
    { layerSlug: 'midwear', sequence: 1, product: null },
    { layerSlug: 'innerwear', sequence: 2, product: null },
    { layerSlug: 'bottoms', sequence: 3, product: null },
    { layerSlug: 'footwear', sequence: 4, product: null },
    { layerSlug: 'accessories1', sequence: 5, product: null },
    { layerSlug: 'accessories2', sequence: 6, product: null },
  ],
  currentWardrobe: null,
  currentWardrobeProduct: null,
  wardrobeDataStates: {
    wardrobe: { fetching: false, loaded: false },
    products: { fetching: false, loaded: false },
    outfits: { fetching: false, loaded: false },
  },
  wardrobeBuilderMode: false,
  wardrobeError: '',
  wardrobeOutfits: [],
  wardrobeProductIdsPending: [],
  wardrobeProducts: []
};

const getters = {
  builderOutfit: state => state.builderOutfit,
  currentWardrobe: state => state.currentWardrobe,
  currentWardrobeProduct: state => state.currentWardrobeProduct,
  wardrobeOutfits: state => state.wardrobeOutfits,
  wardrobeProductIdsPending: state => state.wardrobeProductIdsPending,
  wardrobeProducts: state => state.wardrobeProducts,
  wardrobeBuilderMode: state => state.wardrobeBuilderMode,
  wardrobeDataStates: state => state.wardrobeDataStates
};

const actions = {
  async resetBuilderOutfit({ commit, state }) {
    const outfitData = [
      { layerSlug: 'outerwear', sequence: 0, product: null },
      { layerSlug: 'midwear', sequence: 1, product: null },
      { layerSlug: 'innerwear', sequence: 2, product: null },
      { layerSlug: 'bottoms', sequence: 3, product: null },
      { layerSlug: 'footwear', sequence: 4, product: null },
      { layerSlug: 'accessories1', sequence: 5, product: null },
      { layerSlug: 'accessories2', sequence: 6, product: null },
    ];

    commit('SAVE_BUILDER_OUTFIT', outfitData);
  },

  async resetWardrobeDataStates({ commit }) {
    commit('SET_WARDROBE_DATA_STATE_LOADED', { type: 'wardrobe', value: false });
    commit('SET_WARDROBE_DATA_STATE_LOADED', { type: 'products', value: false });
    commit('SET_WARDROBE_DATA_STATE_LOADED', { type: 'outfits', value: false });
  },

  async setWardrobeBuilderMode({ commit }, value) {
    commit('SET_WARDROBE_BUILDER_MODE', value)

    return true;
  },

  async addProductToBuilderOutfit({ commit, state }, wardrobeProduct) {
    let payload = null
    if (wardrobeProduct.group === "accessories") {
      payload = state.builderOutfit.find(el => el.layerSlug.includes(wardrobeProduct.group) && el.product == null)

      if (payload == null) {
        payload = state.builderOutfit.find(el => el.layerSlug.includes(wardrobeProduct.group))
      }
    } else {
      payload = state.builderOutfit.find(el => el.layerSlug === wardrobeProduct.group)
    }

    if (payload) {
      payload = { ...payload, ...{ product: wardrobeProduct.product } }
      commit('SET_PRODUCT_IN_BUILDER_OUTFIT', payload)
      return true;
    }
  },

  async removeProductFromBuilderOutfit({ commit, state }, wardrobeProduct) {
    let payload = state.builderOutfit.find(
      el => el.layerSlug.includes(wardrobeProduct.group) && el.product.id === wardrobeProduct.product.id
    )

    if (payload) {
      payload = { ...payload, ...{ product: null } }
      commit('SET_PRODUCT_IN_BUILDER_OUTFIT', payload)
      return true;
    }
  },

  async fetchCurrentWardrobe({ commit }, payload) {
    commit('SET_WARDROBE_DATA_STATE_FETCHING_TRUE', 'wardrobe');

    const { data, message } = await handleGetWardrobe(payload.wardrobeId)

    if (data) {
      commit('SET_WARDROBE_DATA_STATE_LOADED', { type: 'wardrobe', value: true });
      commit('SAVE_CURRENT_WARDROBE', data['wardrobe']);

    } else {
      commit('SET_WARDROBE_DATA_STATE_LOADED', { type: 'wardrobe', value: false });
      commit('SAVE_WARDROBE_ERROR_RESPONSE', message);

    }
  },

  async fetchCurrentWardrobeProduct({ commit }, { wardrobeId, productId }) {
    const payload = {
      wardrobeId: wardrobeId,
      productIds: productId,
      limit: 1
    }

    const { data, message } = await handleGetWardrobeProducts(payload);

    if (data) {
      commit('SAVE_CURRENT_WARDROBE_PRODUCT', data['wardrobe_products'][0]);

    } else {
      commit('SAVE_WARDROBE_ERROR_RESPONSE', message);
    }
  },

  async fetchWardrobeProducts({ commit, dispatch }, wardrobeId) {
    commit('SET_WARDROBE_DATA_STATE_FETCHING_TRUE', 'products');

    const { data, message } = await handleGetWardrobeProducts({ wardrobeId: wardrobeId })

    if (data) {
      commit('SET_WARDROBE_DATA_STATE_LOADED', { type: 'products', value: true });
      commit('SAVE_WARDROBE_PRODUCTS', data['wardrobe_products']);
      dispatch('setWardrobeProductIdsPending', wardrobeProductIdsWithoutProducts(data['wardrobe_products']));

    } else {
      commit('SET_WARDROBE_DATA_STATE_LOADED', { type: 'products', value: false });
      commit('SAVE_WARDROBE_ERROR_RESPONSE', message);
    }
  },

  setWardrobeProductIdsPending({ commit }, idList = []) {
    commit('SET_WARDROBE_PRODUCT_IDS_PENDING', idList);
  },

  setCurrentWardrobeProduct({ commit }, wardrobeProduct = null) {
    commit('SAVE_CURRENT_WARDROBE_PRODUCT', null);
  },

  async pollPendingWardrobeProducts({ commit, state }, wardrobeId) {
    if (state.wardrobeProductIdsPending.length <= 0) return false

    const payload = {
      wardrobeId: wardrobeId,
      wardrobeProductIds: state.wardrobeProductIdsPending,
      assignPendingProducts: true
    }

    const { data, message } = await handleGetWardrobeProducts(payload);

    if (data) {
      data['wardrobe_products'].forEach(wardrobeProduct => {
        if (wardrobeProduct['product']) {
          commit('UPDATE_WARDROBE_PRODUCT', wardrobeProduct)
          commit('REMOVE_WARDROBE_PRODUCT_ID_PENDING', wardrobeProduct)
        }
      })

    } else {
      commit('SAVE_WARDROBE_ERROR_RESPONSE', message);
    }
  },

  async fetchWardrobeOutfits({ commit }, wardrobeId) {
    commit('SET_WARDROBE_DATA_STATE_FETCHING_TRUE', 'outfits');
    const { data, message } = await handleGetWardrobeOutfits(wardrobeId)

    if (data) {
      commit('SET_WARDROBE_DATA_STATE_LOADED', { type: 'outfits', value: true });
      commit('SAVE_WARDROBE_OUTFITS', data['wardrobe_outfits']);

    } else {
      commit('SET_WARDROBE_DATA_STATE_LOADED', { type: 'outfits', value: false });
      commit('SAVE_WARDROBE_ERROR_RESPONSE', message);
    }
  },

  async createWardrobeOutfit({ commit, state }, payload) {
    const productIds = state.builderOutfit.flatMap(entry => {
      if (entry.product) return entry.product.id
    }).filter(Boolean);

    const outfitData = {
      title: payload['outfitTitle'],
      product_ids: productIds
    };

    const { data, message } = await handleCreateWardrobeOutfit(payload.wardrobeId, outfitData);

    if (data) {
      commit('ADD_OUTFIT_TO_WARDROBE_OUTFITS', data['wardrobe_outfit']);
      return true;

    } else {
      commit('SAVE_WARDROBE_ERROR_RESPONSE', message);
      return false;
    }
  },

  destroyWardrobeOutfit({ commit }, { wardrobeId, wardrobeOutfitId }) {
    return WardrobeOutfitService.destroy(wardrobeId, wardrobeOutfitId)
      .then(() => {
        commit('REMOVE_OUTFIT_FROM_WARDROBE_OUTFITS', wardrobeOutfitId)
      })
      .catch(error => {})
  },

  async addWardrobeProduct({ commit }, payload) {
    const { data, message } = await handleAddProductRequest(payload);

    if (data) {
      commit('ADD_WARDROBE_PRODUCT', data['wardrobe_product'])
      commit('SAVE_CURRENT_WARDROBE_PRODUCT', data['wardrobe_product'])

      if (data['wardrobe_product']['product'] == null) {
        commit('ADD_WARDROBE_PRODUCT_ID_PENDING', data['wardrobe_product']['id'])
      }
      return true;
    } else {
      commit('SAVE_WARDROBE_ERROR_RESPONSE', message);
      return false;
    }
  },

  async updateWardrobeProduct({ commit, state }, payload) {
    const { data, message } = await handleUpdateProductRequest(payload);

    if (data) {
      commit('UPDATE_WARDROBE_PRODUCT', data['wardrobe_product'])
      commit('SAVE_CURRENT_WARDROBE_PRODUCT', data['wardrobe_product'])
    } else {
      commit('SAVE_WARDROBE_ERROR_RESPONSE', message);
    }
  },

  async removeWardrobeProduct({ commit }, payload) {
    const { data, message } = await handleRemoveProductRequest(payload);

    if (data) {
      commit('REMOVE_WARDROBE_PRODUCT', data.product_id)
      commit('SAVE_CURRENT_WARDROBE_PRODUCT', null)
    } else {
      commit('SAVE_WARDROBE_ERROR_RESPONSE', message);
    }
  },
};

const mutations = {
  ADD_OUTFIT_TO_WARDROBE_OUTFITS(state, outfit) {
    state.wardrobeOutfits.push(outfit)
    state.currentWardrobe.wardrobe_outfits_count += 1
  },

  REMOVE_OUTFIT_FROM_WARDROBE_OUTFITS(state, wardrobeOutfitId) {
    const index = state.wardrobeOutfits.findIndex(outfit => outfit['id'] === wardrobeOutfitId);

    if (index > -1) {
      state.wardrobeOutfits.splice(index, 1);
      state.currentWardrobe.wardrobe_outfits_count--;
    }
  },

  ADD_WARDROBE_PRODUCT(state, wardrobeProduct) {
    state.wardrobeProducts.push(wardrobeProduct);
    state.currentWardrobe.wardrobe_products_count += 1;
  },

  ADD_WARDROBE_PRODUCT_ID_PENDING(state, id) {
    state.wardrobeProductIdsPending.push(id)
  },

  REMOVE_WARDROBE_PRODUCT(state, productId) {
    const index = state.wardrobeProducts.findIndex((wp) => wp.product.id === productId)

    if (index > -1) {
      state.wardrobeProducts.splice(index, 1);
      state.currentWardrobe.wardrobe_products_count -= 1;
    }
  },

  REMOVE_WARDROBE_PRODUCT_ID_PENDING(state, wardrobeProductId) {
    const index = state.wardrobeProductIdsPending.findIndex((id) => id === wardrobeProductId.id)

    if (index > -1) {
      state.wardrobeProductIdsPending.splice(index, 1);
    }
  },

  SAVE_BUILDER_OUTFIT(state, outfitData) {
    state.builderOutfit = outfitData;
  },

  SAVE_CURRENT_WARDROBE(state, response) {
    state.currentWardrobe = response;
  },

  SAVE_CURRENT_WARDROBE_PRODUCT(state, response) {
    state.currentWardrobeProduct = response;
  },

  SAVE_WARDROBE_ERROR_RESPONSE(state, error) {
    state.wardrobeError = error;
  },

  SAVE_WARDROBE_OUTFITS(state, response) {
    state.wardrobeOutfits = response;
  },

  SAVE_WARDROBE_PRODUCTS(state, response) {
    state.wardrobeProducts = response;
  },

  SET_PRODUCT_IN_BUILDER_OUTFIT(state, outfitData) {
    state.builderOutfit.forEach((item, index) => {
      if (item.layerSlug === outfitData.layerSlug && index > -1) {
        state.builderOutfit.splice(index, 1, outfitData);
      }
    })
  },

  SET_WARDROBE_BUILDER_MODE(state, value) {
    state.wardrobeBuilderMode = value;
  },

  SET_WARDROBE_DATA_STATE_LOADED(state, { type, value }) {
    state.wardrobeDataStates[type]['fetching'] = false;
    state.wardrobeDataStates[type]['loaded'] = value;
  },

  SET_WARDROBE_DATA_STATE_FETCHING_TRUE(state, type) {
    state.wardrobeDataStates[type]['fetching'] = true;
  },

  SET_WARDROBE_PRODUCT_IDS_PENDING(state, list) {
    state.wardrobeProductIdsPending = list
  },

  UPDATE_WARDROBE_PRODUCT(state, wardrobeProduct) {
    const index = state.wardrobeProducts.findIndex((wp) => wp.id === wardrobeProduct.id)

    if (index > -1) state.wardrobeProducts.splice(index, 1, wardrobeProduct);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/wardrobe/index.js